/* eslint-disable no-nested-ternary */
import React, { lazy, useEffect, useContext } from 'react';
import { useAuthUser } from '@nbx/frontend-helpers/subscribe';
import { Context } from 'state/store';
import { setOverlay } from 'state/creators';
import OVERLAYS from 'constants/overlays';

import useNeonomicsSearchParams from '../AddFunds/useNeonomicsSearchParams';
import useAddFundsSearchParam from '../AddFunds/useAddFundsSearchParam';

import { useInstantTradeRedirect } from '../InstantTrade/useInstantTradeRedirect';
import { TermsOfServiceModal, useTermsOfServiceModal } from '../../modals/TermsOfService';

const InstantTrade = lazy(() => import('../InstantTrade'));
const AddFunds = lazy(() => import('../AddFunds'));
const OtcModal = lazy(() => import('../OtcModal'));

export const ModalSwitcher = () => {
  const [state, dispatch] = useContext(Context);

  useInstantTradeRedirect();

  useTermsOfServiceModal();

  const neonomicsParam = useNeonomicsSearchParams();
  const addFundsParam = useAddFundsSearchParam();
  const user = useAuthUser();

  // Open AddFunds overlay if neonomics query params are present
  useEffect(() => {
    if (!user) return;
    if (
      addFundsParam !== null ||
      (neonomicsParam !== null && ['accounts', 'processing', 'error'].includes(neonomicsParam))
    ) {
      dispatch(setOverlay(OVERLAYS.addfunds));
    }
  }, [dispatch, user, addFundsParam, neonomicsParam]);

  // Open AddFunds overlay after Neonomics redirect
  useEffect(() => {
    const queryParameters = new URLSearchParams(location.search);
    const depositResult = queryParameters.get('depositResult');
    if (!depositResult) return;

    dispatch(setOverlay(OVERLAYS.addfunds));
  }, [dispatch]);

  const clearOverlay = () => dispatch(setOverlay(null));

  return (
    <>
      {state.overlay === OVERLAYS.tos && (
        <React.Suspense fallback={React.Fragment}>
          <TermsOfServiceModal onClose={clearOverlay} />
        </React.Suspense>
      )}
      {state.overlay === OVERLAYS.quickbuy && (
        <React.Suspense fallback={React.Fragment}>
          <InstantTrade closeModal={clearOverlay} />
        </React.Suspense>
      )}
      {state.overlay === OVERLAYS.addfunds && (
        <React.Suspense fallback={React.Fragment}>
          <AddFunds closeModal={clearOverlay} />
        </React.Suspense>
      )}
      {state.overlay === OVERLAYS.otc && (
        <React.Suspense fallback={React.Fragment}>
          <OtcModal closeModal={clearOverlay} />
        </React.Suspense>
      )}
    </>
  );
};
